import { render, staticRenderFns } from "./PassportCard.vue?vue&type=template&id=3c33b5a6&"
import script from "./PassportCard.vue?vue&type=script&lang=js&"
export * from "./PassportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports